import LocalStorageAdapter from 'shared/localstorage_adapter.js';
export default class LoginBottomsheet {
  constructor({ element: element }) {
    this.element = element;
    this.cancelButton = element.querySelector('.js-cancel-button');
  }

  init() {
    this.cancelButton.addEventListener('click', this.hide.bind(this));
  }

  show() {
    this.element.classList.remove('hide');
    this.removeLoginOfferingWatchCount();
  }

  hide() {
    this.element.classList.add('hide');
  }

  removeLoginOfferingWatchCount() {
    LocalStorageAdapter.removeItem('login-offering-watch-count');
  }
}
